import { BiLogoPostgresql } from "react-icons/bi";
import { GrMysql } from "react-icons/gr";
import { SiSnowflake, SiShopify, SiMetabase } from "react-icons/si";

export const connectorList = [
  {
    name: "PostgreSQL",
    icon: BiLogoPostgresql,
  },
  {
    name: "Metabase",
    icon: SiMetabase,
  },
  {
    name: "Shopify",
    icon: SiShopify,
  },
  // {
  //   name: "MySQL",
  //   icon: GrMysql,
  // },
  // {
  //   name: "Snowflake",
  //   icon: SiSnowflake,
  // },
];
